import React, { useState } from 'react'
import { hashHistory } from 'react-router'
import Grid from '@material-ui/core/Grid'
import { TablePagination } from '@mui/material'
import TableInc from '../../../../../shared-ui/TableInc'
import ButtonInc from '../../../../../shared-ui/ButtonInc'
import { formatDateLocale } from '../../../../../lib/utils.es6'
import { getPartner } from '../../../../../lib/access.es6'

const DisplayPolicies = props => {
  const [rowsPerPage, setRowsPerPage] = useState(props.size || 10)

  const handleNextPage = () => {
    const payload = {
      page: props.page + 1,
      size: rowsPerPage,
      status: props.status
    }
    props.handleNextPage(payload)
  }

  const partner = getPartner()
  const partnerGuid = partner.guid
  const currencyCode =
    partner && partner.country && partner.country.currency_code
      ? partner.country.currency_code
      : 'N/A'

  // const tempArr = (props.policies || [])
  //   .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
  //   .map(policy => ({
  //     ...policy,
  //     active: policy.active,
  //     created_at: formatDateLocale(policy.created_at) || "N/A",
  //     premium_granularity: (policy.quotation && policy.quotation.total_premium_amount_in_cents)
  //       ? `${currencyCode}  ${policy.quotation.total_premium_amount_in_cents / 100} per ${policy.quotation.premium_cardinality} ${policy.quotation.premium_granularity}` || "0.00"
  //       : "N/A",
  //     agent: (policy.additional_details && policy.additional_details.created_by) ? policy.additional_details.created_by : "N/A",
  //     principal: (policy.additional_details && policy.additional_details.principal_full_names) ? policy.additional_details.principal_full_names : "N/A",
  //     branch: (policy.additional_details && policy.additional_details.branch) ? policy.additional_details.branch : "N/A",
  //   }));
  const tempArr = (props.policies || [])
    .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
    .map(policy => ({
      ...policy,
      active: policy.active,
      created_at: formatDateLocale(policy.created_at) || 'N/A',
      premium_granularity:
        policy.quotation && policy.quotation.total_premium_amount_in_cents
          ? `${currencyCode}  ${policy.quotation.total_premium_amount_in_cents /
              100} per ${policy.quotation.premium_cardinality} ${
              policy.quotation.premium_granularity
            }` || '0.00'
          : 'N/A',
      agent:
        policy.additional_details && policy.additional_details.created_by
          ? policy.additional_details.created_by
          : 'N/A',
      // principal: (policy.additional_details && policy.additional_details.principal_full_names) ? policy.additional_details.principal_full_names : "N/A",
      principal: (() => {
        if (
          policy.quotation &&
          Array.isArray(policy.quotation.policy_schedule_entries)
        ) {
          const entry = policy.quotation.policy_schedule_entries.find(
            e =>
              e.dependant &&
              e.dependant.relationship &&
              e.dependant.relationship === 'Principal'
          )
          if (entry && entry.dependant) {
            return `${entry.dependant.first_name || ''} ${entry.dependant
              .last_name || ''}`.trim()
          }
        }
        return 'N/A'
      })(),
      branch:
        policy.additional_details && policy.additional_details.branch
          ? policy.additional_details.branch
          : 'N/A'
    }))

  // Base columns that are always shown
  const baseColumns = [
    {
      title: 'Policy Number',
      field: 'policy_number',
      render: rowData => rowData.policy_number || 'N/A'
    },
    {
      title: 'Branch',
      field: 'branch',
      render: rowData => rowData.branch || 'N/A'
    }
  ]

  // Conditional columns for old mutual uganda policies
  const oldMutualUgandaPolicies = [
    'centenary_bank',
    'om_rotary',
    'omu_posbank',
    'om_namirembe'
  ]

  const conditionalColumns = oldMutualUgandaPolicies.includes(partnerGuid)
    ? [
        {
          title: 'Agent',
          field: 'agent',
          render: rowData => rowData.agent || 'N/A'
        },
        {
          title: 'Principal',
          field: 'principal',
          render: rowData => rowData.principal || 'N/A'
        }
      ]
    : []

  console.log('tempArr', tempArr)

  // Remaining columns
  const endColumns = [
    {
      title: 'Status',
      field: 'status'
    },
    {
      title: 'Premiums',
      field: 'premium_granularity'
    },
    {
      title: 'Created At',
      field: 'created_at'
    },
    {
      title: 'action',
      field: 'claimaction',
      render: rowData => (
        <div>
          <ButtonInc
            onClick={() =>
              hashHistory.push({
                pathname: `admin/policy-processing/${rowData.policy_number}`,
                query: { from: 'policies_dashboard' }
              })
            }
            variant="contained"
          >
            View Policy
          </ButtonInc>
        </div>
      )
    }
  ]

  // Combine all columns
  const columns = [...baseColumns, ...conditionalColumns, ...endColumns]

  console.log('data', tempArr, 'pages', props.page, props.size, props.total)

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} md={12} sm={12}>
          <TableInc
            columns={columns}
            data={tempArr}
            options={{
              pageSize: props.size,
              page: (props.page || 1) - 1,
              totalCount: props.total,
              paging: false, // Disable built-in paging UI
              showTitle: false,
              search: true
            }}
          />

          <TablePagination
            component="div"
            count={props.total}
            page={props.page - 1}
            rowsPerPage={props.size}
            onPageChange={handleNextPage}
            onRowsPerPageChange={event => {
              const newSize = parseInt(event.target.value, 10)
              setRowsPerPage(newSize)
            }}
          />
        </Grid>
      </Grid>
    </>
  )
}

export default DisplayPolicies
